import { BuyApprovalStatusEnum } from "../../../../enum";
import { Address, BuyConfig } from "../storeAnalytics.types";

export const buyStoreBaseUrl = "https://modulusbuy.com/store/";

export const formatNumber = (value: number) =>
  Number(value || 0).toLocaleString("en-IN");

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value || 0);

export const formatDateTime = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

export const formatAddress = (address?: Address) =>
  address
    ? [
        address.line1,
        address.locality,
        address.city,
        address.state,
        address.postalCode,
      ]
        .filter(Boolean)
        .join(", ")
    : "";

export const isOnBuy = (buyConfig?: BuyConfig) =>
  Boolean(buyConfig?.approvalStatus) || buyConfig?.isEnabled !== undefined;

export const getBuyState = (buyConfig?: BuyConfig) => {
  if (buyConfig?.approvalStatus === BuyApprovalStatusEnum.Pending) {
    return { label: "Under review", className: "pending" };
  }
  if (buyConfig?.approvalStatus === BuyApprovalStatusEnum.Rejected) {
    return { label: "Rejected", className: "rejected" };
  }
  return buyConfig?.isEnabled
    ? { label: "Live", className: "live" }
    : { label: "Paused", className: "paused" };
};
